import React from "react";
import PropTypes from "prop-types";

const SectionCard = ({
  title,
  description,
  actions,
  meta,
  children,
  collapsible,
  open,
  onToggle
}) => (
  <section
    className={`section-card${collapsible ? " section-card--collapsible" : ""}`}
  >
    <div
      className="section-card__header"
      {...(collapsible ? { onClick: onToggle } : {})}
    >
      <div className="section-card__title">
        <h4>{title}</h4>
        {description && <p>{description}</p>}
      </div>
      <div className="section-card__header-actions">
        {meta && <div className="section-card__meta">{meta}</div>}
        {actions && <div className="section-card__actions">{actions}</div>}
      </div>
    </div>
    {(!collapsible || open) && (
      <div className="section-card__body">{children}</div>
    )}
  </section>
);

SectionCard.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  actions: PropTypes.node,
  meta: PropTypes.node,
  children: PropTypes.node.isRequired,
  collapsible: PropTypes.bool,
  open: PropTypes.bool,
  onToggle: PropTypes.func
};

SectionCard.defaultProps = {
  description: null,
  actions: null,
  meta: null,
  collapsible: false,
  open: true,
  onToggle: undefined
};

export default SectionCard;
